import React from 'react';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { find } from 'lodash';

import PostDescription from '../../../DesignSystem/PostDescription';
import CommentsSection from '../../../Comments/Show';
import InteractionsBox from '../../Shared/InteractionsBox';
import DuplicatedPostList from '../../DuplicatedPostList';
import OriginalPost from '../../OriginalPost';
import ContributionFormAnswers from './FormBuilder';

function ParticipationPostShow({ post, space }: any) {
  const intl = useIntl();

  // NOTE: this is a hack, we should have a better way to get the content title
  // but it's working for now since `post_record_questions` only have a `title` and a `description`
  // so the `textarea` is always the description of the Post
  const contentTitle = find(
    post.included.source.post_record_questions,
    (question: any) => question.field_type === 'textarea',
  )?.title;

  return (
    <Box sx={{ mb: 4 }}>
      <Box sx={{ mb: 3 }}>
        <PostDescription
          content={post.content}
          subtitle={contentTitle || intl.formatMessage({ id: 'POSTS.DETAILS.DESCRIPTION_TITLE' })}
        />
      </Box>

      <ContributionFormAnswers post={post} hideConfidentialFields />

      <Box sx={{ mb: 3 }}>
        <InteractionsBox
          post={post}
          space={space}
          direction="row"
          ctaVariant="outlined"
          hasBackground
          onlyPrimaryActions
        />
      </Box>

      <CommentsSection post={post} />
      <OriginalPost post={post} space={space} />
      <DuplicatedPostList post={post} space={space} />
    </Box>
  );
}

export default ParticipationPostShow;
